import { ChangeDetectorRef, Component, EventEmitter, Injector, Input, Output } from '@angular/core';
import { LookupGetService } from '../../service/lookup-service/lookup-get.service';
import { DrugIngredientUtil } from '../../ui/DrugIngredientUtil';

@Component({
  selector: 'app-formly-drug-ingredients-view',
  templateUrl: './formly-drug-ingredients-view.component.html',
  styleUrl: './formly-drug-ingredients-view.component.scss'
})
export class FormlyDrugIngredientsViewComponent {
  @Input() selectedNode: any;
  @Output() modelChange = new EventEmitter<any>();
  lowDenominatorUnit: any;

  constructor(private injector: Injector){
  }

  ngAfterViewInit(){
    setTimeout(() => {
        this.lowDenominatorUnit = DrugIngredientUtil.getLowDenominatorUnit(this.injector.get(LookupGetService),this.selectedNode.data.model);
      });
    }
  onModelChange(model: any) {
    this.modelChange.emit(model);
    this.ngAfterViewInit(); // TO update field wihtout NG0100 Error (see getLowDenominatorUnit())
  }

  setFocusOnFormlyField(fieldName: string) {
   const element: any = document.getElementById(fieldName);
    if (element) {
      if (element instanceof HTMLInputElement) {
        element.focus();
      } else if (element.nodeName === 'SELECT') { // fix for select element
         element.focus();
      }    
    }  
  }

  getSubstance(): string {
    return DrugIngredientUtil.getSubstance(this.selectedNode.data.model.substancecode?.name);
  }

  getStrength():string {
    return DrugIngredientUtil.getStrength(this.selectedNode.data.model.concentrationtypecode?.value);
  }

  getRole():string{
    return DrugIngredientUtil.getRole(this.injector.get(LookupGetService),this.selectedNode.data.model.roleofingredient);
  }

  getLowNumerator(): string {
    return DrugIngredientUtil.getLowNumerator(this.selectedNode.data.model.lowAmountConditionalGroup?.lowamountnumervalue);
  } 

  getLowNumeratorPrefix():string {
    return DrugIngredientUtil.getLowNumeratorPrefix(this.injector.get(LookupGetService),this.selectedNode.data.model.lowAmountConditionalGroup?.lowamountnumerprefix?.value);
  } 

  getLowNumeratorUnit():string {
    return DrugIngredientUtil.getLowNumeratorUnit(this.injector.get(LookupGetService),this.selectedNode.data.model.lowAmountConditionalGroup?.lowamountnumerunit?.value);
  } 
  
  getLowDenominator(): string {
    return DrugIngredientUtil.getLowDenominator(this.selectedNode.data.model.lowAmountConditionalGroup?.lowamountdenomvalue);
  } 
  
  getLowDenominatorPrefix(): string {
    return DrugIngredientUtil.getLowDenominatorPrefix(this.injector.get(LookupGetService),this.selectedNode.data.model.lowAmountConditionalGroup?.lowamountdenomprefix?.value);
  } 
  
  getLowDenominatorUnit(): string {
    // TO FIX ERROR NG0100: ExpressionChangedAfterItHasBeenCheckedError: Expression has changed after it was checked. Previous value: 'true'. Current value: 'false'
    // it is caused because of drawing events in Angular of a property that comes from an observable (lookup)
    // check ngOnImnit()
    //return this.lowDenominatorUnit; 

      return this.lowDenominatorUnit;
} 

  getHighNumerator(): string {
    return DrugIngredientUtil.getHighNumerator(this.selectedNode.data.model.highAmountConditionalGroup?.highamountnumervalue);
  } 
  
  getHighNumeratorPrefix():string {
    return DrugIngredientUtil.getHighNumeratorPrefix(this.injector.get(LookupGetService),this.selectedNode.data.model.highAmountConditionalGroup?.highamountnumerprefix?.value);
  } 


  getConentrationTypeSortLeft() {
    let value = '';

    switch (this.selectedNode.data.model.concentrationtypecode?.value) {
      case 5:
        value = '≈';
        break;
      case 6:
        value = '&#x27e8;';
        break;
      case 1:
        value = '';
        break;
      case 4:
        value = '≥';
        break;
      case 2:
        value = '';
        break;
      case 3:
        value = '≤';
        break;
    }


    return value;
  }

  getConentrationTypeSortRight():string {
    let value: string = '';

    switch (this.selectedNode.data.model.concentrationtypecode?.value) {
      case 5:
        value = '';
        break;
      case 6:
        value = ' &#x27e9;';
        break;
      case 1:
        value = '';
        break;
      case 4:
        value = '';
        break;
      case 2:
        value = ' - ';
        break;
      case 3:
        value = '';
        break;
    }

    return value;
  }

  getConciseLowNumeratorPrefix():string {
    let value = '[prefix]';
    let valueFound = this.selectedNode.data.model.lowAmountConditionalGroup?.lowamountnumerprefix?.value ? this.injector.get(LookupGetService).retrieveValueFromCache('symbol',this.selectedNode.data.model.lowAmountConditionalGroup?.lowamountnumerprefix?.value):value;

    return valueFound;
  } 

  getConciseHighNumeratorPrefix():string {
    let value = '[prefix]';
    let valueFound = this.selectedNode.data.model.highAmountConditionalGroup?.highamountnumerprefix?.value ? this.injector.get(LookupGetService).retrieveValueFromCache('symbol',this.selectedNode.data.model.highAmountConditionalGroup?.highamountnumerprefix?.value):value;

    return valueFound;
  } 

  getConciseLowNumeratorUnit():string {
    let value = '[unit]';
    let valueFound = this.selectedNode.data.model.lowAmountConditionalGroup?.lowamountnumerunit?.value ? this.injector.get(LookupGetService).retrieveValueFromCache('concentrationunitnum',this.selectedNode.data.model.lowAmountConditionalGroup?.lowamountnumerunit?.value):value;

    return valueFound;
  } 

  getConciseLowDenominatorUnit(): string {
    let value = '[unit]';
    let valueFound = this.selectedNode.data.model.lowAmountConditionalGroup?.lowamountdenomunit?.value ? this.injector.get(LookupGetService).retrieveValueFromCache('concentrationunitden',this.selectedNode.data.model.lowAmountConditionalGroup?.lowamountdenomunit?.value):value;
    return valueFound;
  } 
  
  getConciseLowDenominatorPrefix():string {
    let value = '[prefix]';
    let valueFound = this.selectedNode.data.model.lowAmountConditionalGroup?.lowamountdenomprefix?.value ? this.injector.get(LookupGetService).retrieveValueFromCache('symbol',this.selectedNode.data.model.lowAmountConditionalGroup?.lowamountdenomprefix?.value):value;

    return valueFound;
  }
  
  getConcisePrefixUnit(): boolean {
    return ((this.getConciseLowNumeratorPrefix() != '[prefix]') && (this.getConciseHighNumeratorPrefix() != '[prefix]') && this.getConciseLowNumeratorPrefix() == this.getConciseHighNumeratorPrefix());
  }

  getPrefixUnit(): boolean {
    return ((this.getLowNumeratorPrefix() != '[prefix]') && (this.getHighNumeratorPrefix() != '[prefix]') && this.getLowNumeratorPrefix() == this.getHighNumeratorPrefix());
  }

  
}
